import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { PageHero, Section, fadeUp } from "../components/sections";
import SeoHead from "../components/SeoHead";
import { apiClient } from "../lib/site";

export default function CaseStudiesPage() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    apiClient
      .get("/case-studies")
      .then((r) => setItems(r.data))
      .catch(() => setItems([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="case-studies-page">
      <SeoHead
        title="Case Studies"
        description="Selected work: cross-border trade finance, statewide care coordination, composable commerce for 47 brands, pre-emptive logistics control towers, citizen services portals, and adaptive education platforms."
        path="/case-studies"
      />
      <PageHero
        overline="Case Studies"
        title={<>Outcomes we'll defend in front of an auditor.</>}
        intro="A selection of platforms we have architected, built, and operated for enterprise clients across seven industries."
        testId="case-studies-hero"
      />

      <Section className="bg-[#050505]">
        {loading && (
          <p className="text-zinc-500 text-sm">Loading…</p>
        )}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-16">
          {items.map((c, i) => (
            <motion.article
              key={c.slug}
              {...fadeUp}
              transition={{ ...fadeUp.transition, delay: i * 0.06 }}
              data-testid={`case-card-${c.slug}`}
            >
              <Link to={`/case-studies/${c.slug}`} className="group block">
                <div className="aspect-[4/3] overflow-hidden mb-8 bg-[#0A0A0C]">
                  <img
                    src={c.cover_image}
                    alt={c.title}
                    className="w-full h-full object-cover opacity-90 transition-transform duration-700 group-hover:scale-105"
                  />
                </div>
                <p className="overline mb-4" style={{ color: "#71717A" }}>
                  {c.industry} · {c.client} · {c.duration}
                </p>
                <h3 className="font-serif-display text-3xl md:text-4xl text-white font-light leading-snug group-hover:text-zinc-200 transition">
                  {c.title}
                </h3>
                <p className="mt-5 text-zinc-400 text-base leading-relaxed">{c.summary}</p>
                <p className="mt-8 inline-flex items-center gap-2 text-white text-sm tracking-wide">
                  Read case study{" "}
                  <ArrowUpRight size={14} strokeWidth={1.5} className="transition-transform group-hover:translate-x-1 group-hover:-translate-y-1" />
                </p>
              </Link>
            </motion.article>
          ))}
        </div>
      </Section>
    </div>
  );
}
